<template src="../templates/mentor-profile.pug" lang="pug"></template>

<script>
export default {
  name: "mentorProfile",
  props: ["mentor"],
  data() {
    return {
      // mentorz
    };
  }
};
</script>

<style lang="sass" scoped>

.search-result-image
  width: 100%
  height: 150px
  border-radius: 50%
  max-width: 150px
  display: block
  margin: 0 auto

.modal-card
  margin-top: 50px !important
  max-height: calc(100vh - 200px) !important
</style>
